import {TouchEventHandler, useCallback, WheelEventHandler} from "react";

import {ITrackAmplitudeComponentActionParams} from "./track_amplitude_component_action";
import {useTrackAmplitudeComponentActionOnce} from "./use_track_amplitude_component_action_once";

type ITrackAmplitudeMapComponentActionParams = Omit<ITrackAmplitudeComponentActionParams, "action" | "componentName">;

export const useTrackAmplitudeMapComponentActionOnce = (params: ITrackAmplitudeMapComponentActionParams) => {
    const trackInteraction = useTrackAmplitudeComponentActionOnce({
        ...params,
        componentName: "investment_location_map"
    });

    // Keep tracking aligned with leaflet-gesture-handling: one-finger touch and unmodified wheel scroll the page instead of operating the map.
    const trackTouchInteraction = useCallback<TouchEventHandler<HTMLElement>>(
        (event) => {
            if (event.touches.length > 1) {
                trackInteraction();
            }
        },
        [trackInteraction]
    );

    const trackWheelInteraction = useCallback<WheelEventHandler<HTMLElement>>(
        (event) => {
            if (event.ctrlKey || event.metaKey) {
                trackInteraction();
            }
        },
        [trackInteraction]
    );

    return {
        onClickCapture: trackInteraction,
        onMouseDownCapture: trackInteraction,
        onTouchStartCapture: trackTouchInteraction,
        onWheelCapture: trackWheelInteraction
    };
};
import {TouchEventHandler, useCallback, WheelEventHandler} from "react";

import {ITrackAmplitudeComponentActionParams} from "./track_amplitude_component_action";
import {useTrackAmplitudeComponentActionOnce} from "./use_track_amplitude_component_action_once";

type ITrackAmplitudeMapComponentActionParams = Omit<ITrackAmplitudeComponentActionParams, "action" | "componentName">;

export const useTrackAmplitudeMapComponentActionOnce = (params: ITrackAmplitudeMapComponentActionParams) => {
    const trackInteraction = useTrackAmplitudeComponentActionOnce({
        ...params,
        componentName: "investment_location_map"
    });

    // Keep tracking aligned with leaflet-gesture-handling: one-finger touch and unmodified wheel scroll the page instead of operating the map.
    const trackTouchInteraction = useCallback<TouchEventHandler<HTMLElement>>(
        (event) => {
            if (event.touches.length > 1) {
                trackInteraction();
            }
        },
        [trackInteraction]
    );

    const trackWheelInteraction = useCallback<WheelEventHandler<HTMLElement>>(
        (event) => {
            if (event.ctrlKey || event.metaKey) {
                trackInteraction();
            }
        },
        [trackInteraction]
    );

    return {
        onClickCapture: trackInteraction,
        onMouseDownCapture: trackInteraction,
        onTouchStartCapture: trackTouchInteraction,
        onWheelCapture: trackWheelInteraction
    };
};
